import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { List } from 'material-ui/List';

import AssignmentDetail from '../../Assignments/components/AssignmentDetail';
import AssignmentListItem from '../../Assignments/components/AssignmentListItem';
import * as ParseService from '../../../services/parse';

import '../../Assignments/styles/assignments.css';

class CourseAssignmentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      selectedItem: null
    };
  }

  componentDidMount() {
    console.log("Component did mount!");
    this.fetchItems(this.props.course);
  }

  componentWillReceiveProps(props) {
    console.log("Component will receive props...");
    if (props.course.id !== this.props.course.id) {
      this.setState({items: []});
      this.fetchItems(props.course);  
    }
  }

  fetchItems = (course) => {
    const that = this;
    
    ParseService.findAssignmentsByCourse(course, {
      success: function(results) {
        //if (that.props.course.id === course.id) {
          that.setState({items: results});  
        //} 
      },
      failure: function(err) {
        console.log('Failed to fetch course Assignments ' + err);
      }
    });
  }

  handleAssignmentProgressChange = (e, item) => {
   const that = this;
    ParseService.toggleAssignmentProgress(item).then(
      function(obj) {
        //if (that.state.selectedItem.id === obj.id) {
          //that.setState({selectedItem: obj});
        //}
        that.forceUpdate();
      },
      function(err) {
        console.log("Failed to update progress with error " + err);
      });
  }

  render() {
    return (
      <div className="course-assignment-list list-content">
        <div className='course-relation__title'>Assignments</div>

        <div className="list-content__list">
          <List>
            {this.state.items.map((item) =>
              <AssignmentListItem 
                key={item.id}
                item={item} 
                onItemSelected={(item) => this.setState({selectedItem: item})}
                onProgressChange={this.handleAssignmentProgressChange} />
            )}
          </List>
        </div>

        <Dialog
          open={this.state.selectedItem != null}
          onRequestClose={() => this.setState({selectedItem: null})}
          actions={[<FlatButton label='Done' primary={true} onClick={() => this.setState({selectedItem: null})}/>]}
          autoScrollBodyContent={true}>

          <AssignmentDetail 
            item={this.state.selectedItem}
            showActionBar={false}
            onProgressChange={this.handleAssignmentProgressChange} />

        </Dialog>
      </div>
    );
  }
}

export default CourseAssignmentList;


// WEBPACK FOOTER //
// ./src/scenes/Organizer/components/CourseAssignmentList.js